import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-find-trainings',
  templateUrl: './find-trainings.component.html',
  styleUrls: ['./find-trainings.component.scss']
})
export class FindTrainingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
